
import Navbar from "../component/Navbar";

function Home() {
    return (

        <>
        <Navbar/>
      <div>
        <h1>Home Page</h1>
        <p>Welcome to the Home page.</p>
      </div>
      </>
    );
  }
  
  export default Home;
  